<template lang="html">
  <div id="NoPage">
    <div class="background" />
  </div>
</template>
<script>
export default {
  name: 'NoPage',
  components: {},
  data: () => ({}),
  mounted() {
    this.$vs.dialog({
      color: 'danger',
      title: 'Page not found',
      text: '올바르지 않은 접근입니다. 메인으로 이동합니다.',
      acceptText: '네. 알겠습니다.',
      accept: _ => {
        this.$router.push('/')
      }
    })
  }
}

</script>
<style lang="scss" scoped>
#NoPage {
  .background {
    background-image: url('../../assets/main_background.png');
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    background-position: center;
    background-size: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NoPage/index.vue